export default __webpack_public_path__ + "static/media/team1@2x.662b083f.png";